import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';

/**
 * Normalizes an entity reference string.
 *
 * Example: 'name' -> 'kind:namespace/name'
 */
export const normalizeEntityRef = (ref: string, defaultKind?: string) =>
  stringifyEntityRef(parseEntityRef(ref, { defaultKind }));
